export default "__VITE_ASSET__0nPvsdDH__"